<template>
  <div class="groups">
    <div class="header">
      <div class="title">{{ 'base.groups' | translate }}</div>

      <v-btn
        v-if="!isConsultant && !isLocked"
        small
        accent
        text
        :loading="loading"
        @click="onClick">
        <span>{{ 'base.edit' | translate }}</span>
      </v-btn>
    </div>

    <v-dialog
      max-width="380"
      v-model="modal.showAddGroups">
      <add-groups-modal
        :items="items"
        @close="modal.showAddGroups = false" 
        @on-update="onUpdateGroups"/>
    </v-dialog>

    <div class="items-list">
      <draggable
        handle=".group-item-handle"
        v-model="items"
        @start="isDragging = true"
        @end="onDragEnd">
        <template
          v-for="(item, index) in items">
          <group-item
            :key="item.id"
            :item="item"
            :base-weight-per-animal="getBaseWeightPerAnimal(item.id)"
            @on-change="onChange"
            @on-update="onUpdate"
            @on-save-direct="onSaveDirectly"/>
        </template>
      </draggable>

      <div v-if="!hasElements" class="no-items">
        {{ 'info.groups_list_empty' | translate }}</div>

    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import Draggable from 'vuedraggable'

import GroupItem from './GroupItem.vue'

import AddGroupsModal from '../dialogs/AddGroupsModal'
import ListItemDelete from '@/components/common/list-item-delete/ListItemDelete'

export default {
  name: 'GroupList',

  components: {
    Draggable,
    GroupItem,
    AddGroupsModal,
    ListItemDelete
  },

  props: {
    id: {
      type: Number,
      required: true
    },
    groups: Array,
    isLocked: Boolean
  },

  data: () => ({
    items: [],
    modal: {
      showAddGroups: false
    },
    loading: false,
    isDragging: false
  }),

  mounted () {
    this.items = this.groups
  },

  methods: {
    ...mapActions('groups', [
      'loadGroupsList'
    ]),

    async loadData () {
      const filters = {
        farm: this.$route.params.farm_id,
        deleted: 'false'
      }
      await this.loadGroupsList(filters)
    },

    async onClick () {
      this.loading = true
      await this.loadData()
      this.loading = false
      this.modal.showAddGroups = true
    },

    onUpdateGroups (groups) {
      this.items = groups
      this.$emit('on-add', groups)
    },

    openAddGroupDialog () {
      this.$emit('on-group-add')
    },

    onDragEnd () {
      const updatedItems = this.items.map((item, index) => ({
        ...item,
        ordering: index + 1
      }))

      this.items = updatedItems
      this.$emit('on-change', updatedItems)

      setTimeout(() => {
        this.isDragging = false
      }, 100)
    },

    onChange () {
      this.$emit('on-change', this.items)
    },

    onUpdate () {
      this.$emit('on-update', this.items)
    },

    onSaveDirectly () {
      // Pass save event to parent without recalculating coefficients
      this.$emit('on-save-direct')
    },

    getBaseWeightPerAnimal (groupId) {
      if (this.$parent.groupInitialWeights) {
        return this.$parent.groupInitialWeights[groupId] || 0
      }
      return 0
    }
  },

  computed: {
    hasElements () {
      return !!this.items.length
    }
  },

  watch: {
    groups: {
      handler (value) {
        if (!this.isDragging) {
          this.items = value
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
  .header {
    padding: 0 16px;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ececec;
  }

  .header .title {
    font-size: 14px;
  }

  .header .add-btn {
    cursor: pointer;
    color: #1DA643;
    font-size: 17px;
    font-weight: 300;
    transition: .5s;
  }

  .header .add-btn:hover {
    color: #44db6f;
    text-decoration: underline;
  }
  
  .no-items {
    height: 50px;
    font-size: 15px;
    opacity: .4;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>